import React, { useCallback, useRef } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { VolumeSlider } from '../VolumeSlider';
import { VolumeRocker as VolumeRockerContainer } from './styled';
export const VolumeRocker = ({ playerInstance, className, setGestureInProgress, isGestureInProgress, muted, volume, styles, }) => {
    const sliderDomContainerRef = useRef(null);
    const getAndReportVolume = useCallback(({ clientX }) => {
        const sliderDomContainer = sliderDomContainerRef.current;
        if (!sliderDomContainer)
            return;
        const { left, width } = sliderDomContainer.getBoundingClientRect();
        const slideValue = clientX - left;
        let volumeValue = slideValue / width;
        volumeValue = Math.max(0, Math.min(1, volumeValue));
        playerInstance.volume = Number.isNaN(volumeValue) ? playerInstance.volume : volumeValue;
    }, [sliderDomContainerRef, playerInstance]);
    const onMouseDown = useCallback((event) => {
        getAndReportVolume(event);
        setGestureInProgress(true);
        event.preventDefault();
        event.stopPropagation();
    }, [getAndReportVolume, setGestureInProgress]);
    const onMouseMove = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
            getAndReportVolume(event);
        }
    }, [isGestureInProgress, getAndReportVolume]);
    const onMouseUp = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [isGestureInProgress]);
    const onClick = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
            setGestureInProgress(false);
        }
    }, [isGestureInProgress, setGestureInProgress]);
    useEventListener('mousemove', onMouseMove, window);
    useEventListener('mouseup', onMouseUp, window);
    useEventListener('click', onClick, window);
    return (React.createElement(VolumeRockerContainer, { style: styles.container, className: `VolumeRocker ${className}`, "data-test": "VolumeRocker-Inner", ref: sliderDomContainerRef, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onClick: onClick },
        React.createElement(VolumeSlider, { styles: styles.slider, playerInstance: playerInstance, volume: volume, muted: muted })));
};
VolumeRocker.defaultProps = {
    className: '',
    styles: {
        container: null,
        slider: {},
    },
};
//# sourceMappingURL=index.js.map